import { render } from "./historical-monitoring.vue?vue&type=template&id=2a5c4f3a&scoped=true"
import script from "./historical-monitoring.vue?vue&type=script&lang=js"
export * from "./historical-monitoring.vue?vue&type=script&lang=js"

import "./historical-monitoring.vue?vue&type=style&index=0&id=2a5c4f3a&lang=less&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5c4f3a"]])

export default __exports__